// HTML cards render straight into the .gh-canvas grid with no wrapper, so
// bare text in one becomes an anonymous grid item: no selector can reach it,
// `.gh-canvas > *` never places it in the main column, and it auto-places
// into the next free 1-track cell (the narrow right-hand `wide` column).
// Wrap each run of loose text + inline elements in a <p> so it sets like
// any other paragraph.
const INLINE = new Set([
    "A", "ABBR", "B", "BR", "CITE", "CODE", "DEL", "DFN", "EM", "I", "INS",
    "KBD", "MARK", "Q", "S", "SAMP", "SMALL", "SPAN", "STRONG", "SUB", "SUP",
    "TIME", "U", "VAR",
]);

export default function looseContent() {
    document.querySelectorAll(".gh-content.gh-canvas").forEach((root) => {
        let run = [];
        const flush = () => {
            const hasContent = run.some(
                (n) => n.nodeType === Node.ELEMENT_NODE || n.textContent.trim()
            );
            if (hasContent) {
                const p = document.createElement("p");
                run[0].before(p);
                p.append(...run);
            }
            run = [];
        };
        for (const node of [...root.childNodes]) {
            const loose =
                node.nodeType === Node.TEXT_NODE ||
                (node.nodeType === Node.ELEMENT_NODE && INLINE.has(node.tagName));
            if (loose) run.push(node);
            else flush(); // a block element or comment (kg-card markers) ends a run
        }
        flush();
    });
}
